import React from 'react';
import { Grid } from '@mui/material';

import { ContainerColumnLeft, InfoField } from '@occc-app/design-system';
import { AudienceAgeWithinTargetingAttributeFragment } from '@occc/graphql';

import { CardLayout } from '@occc/ui-design-system';

export interface IAgeWithinProps {
  ageWithin: AudienceAgeWithinTargetingAttributeFragment;
}
export const AgeWithin: React.FC<IAgeWithinProps> = ({ ageWithin }) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Member profile attributes'>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <InfoField
              label='Minimum age'
              value={ageWithin?.minimumAge}
              noDataMessage='Is not specified'
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <InfoField
              label='Maximum age'
              value={ageWithin?.maximumAge}
              noDataMessage='Is not specified'
            />
          </Grid>
        </Grid>
      </CardLayout>
    </ContainerColumnLeft>
  );
};
